// Cloud Functions (functions/index.js) throws HttpsError with a plain
// English `message` — the backend has no i18n mechanism, so most callable
// errors will always render in English regardless of the app's locale. The
// small set of errors that carry a machine-readable `details.reason` can be
// localized client-side instead of showing the raw message; anything else
// falls back to the backend's English message.
export function localizeBackendError(err, t) {
    const reason = err && err.details && err.details.reason;
    switch (reason) {
        case 'email-not-verified':
            return t('backendErrors.emailNotVerified');
        case 'free-project-limit':
            return t('backendErrors.freeProjectLimit', { limit: err.details.limit });
        default:
            return err.message;
    }
}
